/**
 * --------------------------------------------
 * KANYOS ResultList.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'ResultList'
const DATA_KEY = 'lte.resultlist'
const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const EVENT_DATA_BOUND = `databound${EVENT_KEY}`

// const CLASS_NAME_RESULT_LIST = 'result-list'
const CLASS_NAME_LIST_VIEW = 'list-view'
const CLASS_NAME_IMAGE_VIEW = 'image-view'
const CLASS_NAME_ACTIVE = 'active'
const CLASS_NAME_ASC = 'asc'
const CLASS_NAME_DESC = 'desc'
const CLASS_NAME_MOBILE_BLOCK = 'mobile-block'

const SELECTOR_DATA_TOGGLE = '[data-widget="result-list"]'
const SELECTOR_DATA_TOTAL_COUNT = '[data-result-list-widget="total-count"]'
const SELECTOR_DATA_LIST_VIEW_SWITCH_BUTTON = '[data-result-list-widget="list-view-switch-button"]'
const SELECTOR_DATA_IMAGE_VIEW_SWITCH_BUTTON = '[data-result-list-widget="image-view-switch-button"]'
const SELECTOR_DATA_SORT_HEADER_WIDGET = '[data-result-list-widget="sort-header-widget"]'
const SELECTOR_DATA_SORT_HEADER_SELECT = '[data-result-list-widget="sort-header-select"]'
const SELECTOR_DATA_SORT_ASC_BUTTON = '[data-result-list-widget="sort-asc-button"]'
const SELECTOR_DATA_SORT_DESC_BUTTON = '[data-result-list-widget="sort-desc-button"]'
const SELECTOR_DATA_LIST_VIEW_DESKTOP_SORT_HEADER_CONTAINER = '[data-result-list-widget="list-view-desktop-sort-header-container"]'
const SELECTOR_DATA_LIST_VIEW_DESKTOP_SORT_HEADER_LINK = '[data-result-list-widget="list-view-desktop-sort-header-link"]'
const SELECTOR_DATA_LIST_VIEW_DESKTOP_DATA_CONTAINER = '[data-result-list-widget="list-view-desktop-data-container"]'
const SELECTOR_DATA_LIST_VIEW_MOBILE_DATA_CONTAINER = '[data-result-list-widget="list-view-mobile-data-container"]'
const SELECTOR_DATA_IMAGE_VIEW_DATA_CONTAINER = '[data-result-list-widget="image-view-data-container"]'
const SELECTOR_DATA_PAGINATOR_DESKTOP = '[data-result-list-widget="paginator-desktop"]'
const SELECTOR_DATA_PAGINATOR_MOBILE = '[data-result-list-widget="paginator-mobile"]'
// const SELECTOR_RESULT_LIST = `.${CLASS_NAME_RESULT_LIST}`
const SELECTOR_LIST_VIEW = `.${CLASS_NAME_LIST_VIEW}`
const SELECTOR_IMAGE_VIEW = `.${CLASS_NAME_IMAGE_VIEW}`

const Default = {
  dataSource: undefined,
  defaultView: SELECTOR_LIST_VIEW,
  listViewHeaderLinkClass: 'btn btn-link p-0',
  loadingWidget: '.loading',
  onSorting(item) {
    return item
  },
  onPaging(item) {
    return item
  },
  onListViewDesktopDataBind(item) {
    return item
  },
  onListViewMobileDataBind(item) {
    return item
  },
  onImageViewDataBind(item) {
    return item
  },
  onPaginatorDesktopDataBind(item) {
    return item
  },
  onPaginatorMobileDataBind(item) {
    return item
  }
}

/**
 * Class Definition
 * ====================================================
 */

class ResultList {
  constructor(element, config) {
    this._config = config
    this._element = element

    this._init()
  }

  switchListView() {
    const $listViewSwitchButton = $(this._element).find(SELECTOR_DATA_LIST_VIEW_SWITCH_BUTTON)
    if (!$listViewSwitchButton.hasClass(CLASS_NAME_ACTIVE)) {
      $listViewSwitchButton.addClass(CLASS_NAME_ACTIVE)
    }

    const $imageViewSwitchButton = $(this._element).find(SELECTOR_DATA_IMAGE_VIEW_SWITCH_BUTTON)
    if ($imageViewSwitchButton.hasClass(CLASS_NAME_ACTIVE)) {
      $imageViewSwitchButton.removeClass(CLASS_NAME_ACTIVE)
    }

    const $sortHeaderWidget = $(this._element).find(SELECTOR_DATA_SORT_HEADER_WIDGET)
    if (!$sortHeaderWidget.hasClass(CLASS_NAME_MOBILE_BLOCK)) {
      $sortHeaderWidget.addClass(CLASS_NAME_MOBILE_BLOCK)
    }

    const $listView = $(this._element).find(SELECTOR_LIST_VIEW)
    $listView.show()

    const $imageView = $(this._element).find(SELECTOR_IMAGE_VIEW)
    $imageView.hide()

    $(this._element).data('target', CLASS_NAME_LIST_VIEW)
  }

  switchImageView() {
    const $listViewSwitchButton = $(this._element).find(SELECTOR_DATA_LIST_VIEW_SWITCH_BUTTON)
    if ($listViewSwitchButton.hasClass(CLASS_NAME_ACTIVE)) {
      $listViewSwitchButton.removeClass(CLASS_NAME_ACTIVE)
    }

    const $imageViewSwitchButton = $(this._element).find(SELECTOR_DATA_IMAGE_VIEW_SWITCH_BUTTON)
    if (!$imageViewSwitchButton.hasClass(CLASS_NAME_ACTIVE)) {
      $imageViewSwitchButton.addClass(CLASS_NAME_ACTIVE)
    }

    const $sortHeaderWidget = $(this._element).find(SELECTOR_DATA_SORT_HEADER_WIDGET)
    if ($sortHeaderWidget.hasClass(CLASS_NAME_MOBILE_BLOCK)) {
      $sortHeaderWidget.removeClass(CLASS_NAME_MOBILE_BLOCK)
    }

    const $listView = $(this._element).find(SELECTOR_LIST_VIEW)
    $listView.hide()

    const $imageView = $(this._element).find(SELECTOR_IMAGE_VIEW)
    $imageView.show()

    $(this._element).data('target', CLASS_NAME_IMAGE_VIEW)
  }

  // Private
  _dataBind() {
    const $totalCount = $(this._element).find(SELECTOR_DATA_TOTAL_COUNT)
    $totalCount.empty().append(this._config.dataSource.TotalCount)

    const $sortHeaderSelect = $(this._element).find(SELECTOR_DATA_SORT_HEADER_SELECT)
    $sortHeaderSelect.empty()

    const $listViewDesktopSortHeaderContainer = $(this._element).find(SELECTOR_DATA_LIST_VIEW_DESKTOP_SORT_HEADER_CONTAINER)
    $listViewDesktopSortHeaderContainer.empty()

    for (let i = 0; i < this._config.dataSource.ColumnHearders.length; i++) {
      const columnHeader = this._config.dataSource.ColumnHearders[i]
      const columnText = columnHeader.ColumnText === null ? '&nbsp;' : columnHeader.ColumnText

      if (columnHeader.ColumnText !== null) {
        const $sortHeaderOption = $('<option />', {
          text: columnText,
          value: columnHeader.SortHeader,
          selected: this._config.dataSource.CurrentSortHeader === columnHeader.SortHeader
        })

        $sortHeaderSelect.append($sortHeaderOption)
      }

      let columnClass = ''
      if (this._config.dataSource.CurrentSortHeader === columnHeader.SortHeader) {
        columnClass = this._config.dataSource.CurrentIsAsc ? CLASS_NAME_ASC : CLASS_NAME_DESC
      }

      let isAsc = ''
      if (this._config.dataSource.CurrentSortHeader === columnHeader.SortHeader) {
        isAsc = this._config.dataSource.CurrentIsAsc
      }

      const $headerColumnLink = $(`<a>${columnText}</a>`)

      $headerColumnLink.attr({
        class: this._config.listViewHeaderLinkClass,
        'data-sort-header': columnHeader.SortHeader,
        'data-is-asc': isAsc,
        'data-result-list-widget': 'list-view-desktop-sort-header-link'
      })

      const $headerColumn = $('<th />', {
        class: columnClass
      }).append($headerColumnLink)

      $listViewDesktopSortHeaderContainer.append($headerColumn)
    }

    const $sortAscButton = $(this._element).find(SELECTOR_DATA_SORT_ASC_BUTTON)
    if ($sortAscButton.hasClass(CLASS_NAME_ACTIVE)) {
      $sortAscButton.removeClass(CLASS_NAME_ACTIVE)
    }

    const $sortDescButton = $(this._element).find(SELECTOR_DATA_SORT_DESC_BUTTON)
    if ($sortDescButton.hasClass(CLASS_NAME_ACTIVE)) {
      $sortDescButton.removeClass(CLASS_NAME_ACTIVE)
    }

    if (this._config.dataSource.CurrentIsAsc) {
      $sortAscButton.addClass(CLASS_NAME_ACTIVE)
    } else {
      $sortDescButton.addClass(CLASS_NAME_ACTIVE)
    }

    const $listViewDesktopDataContainer = $(this._element).find(SELECTOR_DATA_LIST_VIEW_DESKTOP_DATA_CONTAINER)
    this._config.onListViewDesktopDataBind.call(this._element, $listViewDesktopDataContainer, this._config.dataSource)

    const $listViewMobileDataContainer = $(this._element).find(SELECTOR_DATA_LIST_VIEW_MOBILE_DATA_CONTAINER)
    this._config.onListViewMobileDataBind.call(this._element, $listViewMobileDataContainer, this._config.dataSource)

    const $imageViewDataContainer = $(this._element).find(SELECTOR_DATA_IMAGE_VIEW_DATA_CONTAINER)
    this._config.onImageViewDataBind.call(this._element, $imageViewDataContainer, this._config.dataSource)

    const $paginatorDesktop = $(this._element).find(SELECTOR_DATA_PAGINATOR_DESKTOP)
    this._config.onPaginatorDesktopDataBind.call(this._element, $paginatorDesktop, this._config.dataSource)

    const $paginatorMobile = $(this._element).find(SELECTOR_DATA_PAGINATOR_MOBILE)
    this._config.onPaginatorMobileDataBind.call(this._element, $paginatorMobile, this._config.dataSource)

    $(this._element).trigger($.Event(EVENT_DATA_BOUND))
  }

  _eventBind() {
    this._element.off()

    this._element.on('click', SELECTOR_DATA_LIST_VIEW_SWITCH_BUTTON, () => {
      this.switchListView()
    })

    this._element.on('click', SELECTOR_DATA_IMAGE_VIEW_SWITCH_BUTTON, () => {
      this.switchImageView()
    })

    this._element.on('change', SELECTOR_DATA_SORT_HEADER_WIDGET, event => {
      const sortHeader = $(event.target).val()
      const isAsc = this._config.dataSource.CurrentIsAsc
      $(this._config.loadingWidget).show()
      this._config.onSorting.call($(event.target), sortHeader, isAsc)
    })

    this._element.on('click', SELECTOR_DATA_SORT_ASC_BUTTON, this._config.dataSource, event => {
      const sortHeader = event.data.CurrentSortHeader
      const isAsc = true
      $(this._config.loadingWidget).show()
      this._config.onSorting.call($(event.target), sortHeader, isAsc)
    })

    this._element.on('click', SELECTOR_DATA_SORT_DESC_BUTTON, this._config.dataSource, event => {
      const sortHeader = event.data.CurrentSortHeader
      const isAsc = false
      $(this._config.loadingWidget).show()
      this._config.onSorting.call($(event.target), sortHeader, isAsc)
    })

    this._element.on('click', SELECTOR_DATA_LIST_VIEW_DESKTOP_SORT_HEADER_LINK, event => {
      const $headerLink = $(event.target)
      const sortHeader = $headerLink.data('sortHeader')
      const isAsc = typeof $headerLink.data('isAsc') === 'string' ? true : !$headerLink.data('isAsc')
      $(this._config.loadingWidget).show()
      this._config.onSorting.call($headerLink, sortHeader, isAsc)
    })
  }

  _init() {
    if (this._config.dataSource === undefined ||
      this._config.dataSource.ListData === undefined ||
      this._config.dataSource.ListData.length === 0) {
      return
    }

    this._dataBind()
    this._eventBind()

    const targetView = $(this._element).data('target')
    if (targetView !== undefined && targetView === CLASS_NAME_LIST_VIEW) {
      this.switchListView()
    } else if (targetView !== undefined && targetView === CLASS_NAME_IMAGE_VIEW) {
      this.switchImageView()
    } else if (this._config.defaultView === SELECTOR_LIST_VIEW) {
      this.switchListView()
    } else if (this._config.defaultView === SELECTOR_IMAGE_VIEW) {
      this.switchImageView()
    }

    $(this._element).show()
    $(this._config.loadingWidget).hide()
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
      }

      const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
      const plugin = new ResultList($(this), _options)

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (config === 'init') {
        plugin[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

$(window).on('load', () => {
  $(SELECTOR_DATA_TOGGLE).hide()
  // ResultList._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
})

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = ResultList._jQueryInterface
$.fn[NAME].Constructor = ResultList
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return ResultList._jQueryInterface
}

export default ResultList
